import { Box, CardMedia, Skeleton } from '@mui/material';

import { AccountLogoProps } from './AccountLogo.interface';
import logos from './AccountLogo.constants';

import usePlaidInstitutionById from 'services/plaid/queries/usePlaidInstitutionById';
import BankIcon from 'modules/common/components/Icons/BankIcon';

export default function AccountLogo({ institutionId, width = 56, height = 56 }: AccountLogoProps) {
    const fallback = logos[institutionId];
    const { data, isLoading } = usePlaidInstitutionById(institutionId, { enabled: !fallback });

    if (!fallback && isLoading) {
        return <Skeleton variant="rectangular" width={width} height={height} />;
    }

    if (fallback || data?.logo) {
        return (
            <CardMedia
                component="img"
                image={fallback ?? `data:image/jpeg;base64,${data?.logo}`}
                title={data?.name}
                sx={{ width, height, borderRadius: 1 }}
            />
        );
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width={width}
            height={height}
            borderRadius={1}
            bgcolor={data?.primary_color ?? 'cement.500'}
            color="white"
            fontSize="1.65rem">
            <BankIcon fontSize="inherit" fill="currentColor" />
        </Box>
    );
}
